import { useCookies } from 'react-cookie'
import Cookies from 'universal-cookie'

import LocalTextFilter from 'components/filters/LocalTextFilter'
import ScryfallFilter from 'components/filters/ScryfallFilter'
import ArchidektDropdown from 'components/elements/ArchidektDropdown'
import PhatButton from 'components/formElements/PhatButton'
import Icon, { IconTypes } from 'components/elements/Icon'

import { CardType } from 'types/deck'

import styles from './deckFilter.module.scss'
import { expirationDurations } from 'services/cookie.service'

const FILTER_COOKIE_KEY = 'filterType'

type Props = {
  cardsToFilter: CardType[]
  filteredCards: string[]
  setFilteredCards: (cardNames: string[]) => void
  className?: string
}

const CardFilters = ({ cardsToFilter, filteredCards, setFilteredCards, className = '' }: Props) => {
  const [{ filterType: filterType = 'archidekt' }, setCookies] = useCookies(['filterType'])

  const setFilterType = (filterType: 'archidekt' | 'syntax') => {
    setCookies(FILTER_COOKIE_KEY, filterType, {
      path: '/',
      expires: new Date(Date.now() + 1000 * 60 * 60 * 24 * 40),
    })

    // react-cookie doesn't support high priority
    const cookies = new Cookies()

    cookies.set(FILTER_COOKIE_KEY, filterType, {
      path: '/',
      maxAge: expirationDurations.year,
      sameSite: 'lax',
      httpOnly: false,
      // @ts-ignore - high priority cookie is a thing
      priority: 'High',
    })
  }

  return (
    <div className={`${styles.container} ${className}`}>
      {filterType === 'syntax' && (
        <ScryfallFilter
          className={styles.deckFilter}
          cardsToFilter={cardsToFilter}
          filteredCards={filteredCards}
          setFilteredCards={setFilteredCards}
        />
      )}

      {filterType === 'archidekt' && (
        <LocalTextFilter
          cardsToFilter={cardsToFilter}
          filteredCards={filteredCards}
          setFilteredCards={setFilteredCards}
          header="Local filter"
          placeholder="Filter deck (eg: Sol Ring)"
        />
      )}

      <ArchidektDropdown
        menuClassName={styles.changeFilterMenu}
        options={[
          {
            label: 'Local filter',
            id: 'archidekt',
            icon: filterType === 'archidekt' ? ('circle check' as IconTypes) : ('circle outline' as IconTypes),
            onClick: () => setFilterType('archidekt'),
          },
          {
            label: 'Syntax filter',
            id: 'syntax',
            icon: filterType === 'syntax' ? ('circle check' as IconTypes) : ('circle outline' as IconTypes),
            onClick: () => setFilterType('syntax'),
          },
        ]}>
        <PhatButton className={styles.changeFilterTrigger}>
          <Icon name="cog" />
        </PhatButton>
      </ArchidektDropdown>
    </div>
  )
}

export default CardFilters
